
const Constants = {
    EVENT_UPLOAD_START: "upload-start",
    EVENT_UPLOAD_REMAINING_COUNT: 'upload-remaining-count',
    EVENT_UPLOAD_PROGRESS: 'upload-progress',
    EVENT_UPLOAD_FINISHED: 'upload-finished',
    EVENT_UPLOAD_AGAIN: 'upload-again',
    EVENT_UPLOAD_CLEAR: 'upload-clear',
    BANNER_SHOW: 'banner-show',
    BANNER_HIDE: 'banner-hide'
}

export default Constants;
